import { type Spec } from "immutability-helper";
import { createDndContext } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

/**
 * Moves data item from position it was dragged at to the position the cursor is currently hovering
 */
export function moveDragItemToHoverPosition<T>(
    data: T[],
    dragIndex: number,
    hoverIndex: number,
): Spec<T[], never> {
    const dragRow = data[dragIndex];
    return {
        $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
        ],
    };
}

export const GlobalDnDContext = createDndContext(HTML5Backend);
